// Shared finance configuration constants — single source of truth for values
// that several finance pages key off of. Keeping them here prevents the same
// magic number drifting between FinanceCommittees, FinanceBoardPacket, etc.

/**
 * FALLBACK FY27 comparator. Prefer the SERVED value — the FY27 build API returns
 * `target` (FY27_RECURRING_TARGET = $4,098,224, the county's loaded FY27 base
 * appropriation, re-anchored 7/19/2026; the old $3,956,807 was the retired-v1
 * 6/15 re-anchor). Pages should read `fy27?.target ?? ALLOCATION` so ONE number
 * drives every "ask vs base" gap. This constant only covers the brief window
 * before the build data loads; it is pinned to the SAME figure so on-screen gap
 * math never disagrees with the server.
 */
export const ALLOCATION = 4_098_224;
